enum StudentSchoolTypeInShortKor {
  ELEMENTARY = '초',
  MIDDLE = '중',
  HIGH = '고',
}

export const studentUtils = {
  getStudentSchoolTypeInKor: (status: string) => {
    return StudentSchoolTypeInShortKor[status]
  },
}
